/* eslint-disable zeffo/no-window-storage */

/**
 * Quick check if the Soft PIP state is stored in localStorage or sessionStorage.
 * Storage key does not use constant to avoid dependency. This function
 * should be very light-weight and fast to check.
 */
export const quickCheckSoftPIPState = (
  __window_dependency_injection: Window | undefined = typeof window !==
  'undefined'
    ? window
    : undefined,
) => {
  if (
    __window_dependency_injection?.localStorage.getItem('fw_ply_sft_pip') ||
    __window_dependency_injection?.sessionStorage.getItem('fw_ply_sft_pip')
  ) {
    return true
  }
  return false
}
